import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class blogPostContentSlider {
  constructor() {
    this.sliderContainerSelector = 'blog-page-content__slider-slider';
    this.slideSelector = 'blog-page-content-slider__wrapper';

    this.navigation = {
      nextEl: '.one-level-slider__nav_next',
      prevEl: '.one-level-slider__nav_prev',
      disabledClass: 'one-level-slider__nav_disable',
      hiddenClass: 'one-level-slider__nav_hidden',
    };

    this.sliderDocumentContainerSelector = 'slider-documents__container';
    this.slideDocumentSelector = 'slider-documents__slide';

    this.navigationDocument = {
      prevEl: '.brand-slider__nav_prev',
      nextEl: '.brand-slider__nav_next',
      disabledClass: 'brand-slider__nav_disable',
      hiddenClass: 'brand-slider__nav_hidden',
    };

    this.paginationDocument = {
      el: '.brand-slider__pagination',
      lockClass: 'brand-slider__pagination_disable',
    };

    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    setTimeout(() => {
      this.initContentSlider();
      this.initDocumentSlider();
    }, 400);
  }

  initContentSlider() {
    const slider = document.querySelector(`.${this.sliderContainerSelector}`);

    if (!slider) return;

    const { navigation } = this;

    this.HeroSlider = new Swiper(`.${this.sliderContainerSelector}`, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      navigation,
    });
  }

  initDocumentSlider() {
    const sliderDocument = document.querySelector(`.${this.sliderDocumentContainerSelector}`);

    if (!sliderDocument) return;

    const { navigationDocument, paginationDocument } = this;

    this.blogSlider = new Swiper(`.${this.sliderDocumentContainerSelector}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: navigationDocument,
      pagination: paginationDocument,
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    });
  }
}();
